import React, { Component } from 'react';

import './styles.css';

function LocationPoint({ text }) {
  return (
    <div className="marker">
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}

export default LocationPoint;
